import Vue from "vue";
import Vuex from "vuex";
import ApplicationCredentials from "@/credential/application-credentials";
import TagsStorage from "@/tags-storage.js"
import BackendClient from "@/rest/backend-client";

Vue.use(Vuex);

class Error {
  constructor(id, msg) {
    this.id = id;
    this.msg = msg;
  }
}

const credentials = new ApplicationCredentials();
const tagsStorage = new TagsStorage();

const setLoggedInUserFromCredentials = (state) => {
  const userName = credentials.getLoggedInUser();
  state.userLoggedIn = !!userName;
  state.loggedInUserName = userName;
}

const MISSING_PAYMENT_NOTICES = {
    'TRIAL_ENDED': 'Your free trial has ended. We hope you enjoyed it! <a href="/profile">Subscribe</a> to keep using <b>just bookmark it!</b>',
    'EXPIRED': 'Your subscription has expired. <a href="/profile">Renew your subscription</a> to keep using <b>just bookmark it</b>!'
}

export default new Vuex.Store({
  state: {
    popupOpen: false,
    errors: [],
    userLoggedIn: false,
    loggedInUserName: null,
    ownedTags: {}
  },
  mutations: {
    addError: (state, msg) => {
      console.error(msg)
      state.errors.push(new Error(new Date().getTime(), msg));
    },
    signOutIfExpired: (state) => {
      credentials.signOutIfExpired();
      setLoggedInUserFromCredentials(state);
    },
    loginUser: (state, {auth, userName}) => {
      credentials.saveCredentials(auth, userName);
      setLoggedInUserFromCredentials(state);
    },
    logoutUser: (state) => {
      credentials.clearLoggedInUser();
      setLoggedInUserFromCredentials(state);
      tagsStorage.clearTags();
    },
    clearErrors: state => {
      state.errors.splice(0);
    },
    setPopupOpen(state, isOpen) {
      state.popupOpen = isOpen
    },
    loadTags(state) {
      state.ownedTags = tagsStorage.loadTags() || {};
    }
  },
  actions: {
    showPaymentNotice: ({commit}) => {
        if (credentials.isLoggedIn()) {
            new BackendClient().getUserProfile().then(responseData => {
                const profile = responseData.data;
                if (Object.keys(MISSING_PAYMENT_NOTICES).includes(profile.status)) {
                    commit("addError", MISSING_PAYMENT_NOTICES[profile.status])
                }
            });
        }
    },
  },
  modules: {}
});
